<script>
import Vue, { ComponentOptions } from 'vue';
import AutoNumeric from 'autonumeric';
import VTextField from 'vuetify/es5/components/VTextField';

export default Vue.extend({
    name: 'DecimalInput',
    extends: VTextField,
    props: {
        precision: {
            type: Number,
            default: 1
        },
      pad: {
        type: Boolean,
        default: true
      },
    },
    data() {
        return {
            autonumeric: null, // autonumeric instance
            changedByInput: false // Flag to know if the value is changed by user input
        };
    },
    mounted() {
        this.autonumeric = new AutoNumeric(this.$refs.input, ['numeric', { decimalPlaces: this.precision, emptyInputBehavior: 'null', allowDecimalPadding: this.pad }]);
        this.autonumeric.set(this.value);
    },
    methods: {
        onInput() {
            // User has changed the input
            this.changedByInput = true; // set the flag to true
            this.updateVModel(); // emit v-model
        },
        updateVModel() {
            // emit raw value
            if (this.autonumeric !== null) {
                this.$emit('input', this.autonumeric.getNumber());
            }
        },
        genInput() {
            const listeners = Object.assign({}, this.listeners$);
            delete listeners['change'];
            let element = this.$createElement('input', {
                style: {},
                attrs: {
                    ...this.attrs$,
                    autofocus: this.autofocus,
                    disabled: this.disabled,
                    id: this.computedId,
                    placeholder: this.placeholder,
                    readonly: this.readonly,
                    type: this.type
                },
                on: {
                    blur: this.onBlur,
                    input: this.onInput,
                    focus: this.onFocus,
                    keydown: this.onKeyDown,
                    'autoNumeric:formatted': () => {
                        this.changedByInput = false; // Remove the flag when autonumeric finish formatting
                    }
                },
                ref: 'input'
            });
            return element;
        }
    },
    watch: {
        value(newVal) {
            // Check if the last v-model update is fired by the input
            if (!this.changedByInput) {
                this.autonumeric.set(this.value || null); // Set the AutoNumeric raw value
            }
        }
    }
});
</script>
